import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  operationsAlertListSchema,
  operationsAlertSettingsSchema,
  operationsAlertSettingsUpdateSchema,
  type OperationsAlertListQuery,
  type OperationsAlertSettingsUpdate,
} from '@erp/shared';
import { apiFetch } from '@/lib/api-client';

export const operationsAlertSettingsKey = ['operations-alert-settings'] as const;
const operationsAlertHistoryKey = ['operations-alert-history'] as const;

export function useOperationsAlertSettings() {
  return useQuery({
    queryKey: operationsAlertSettingsKey,
    queryFn: () => apiFetch('/api/v1/operations/alert-settings', operationsAlertSettingsSchema),
  });
}

export function useUpdateOperationsAlertSettings() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: OperationsAlertSettingsUpdate) =>
      apiFetch('/api/v1/operations/alert-settings', operationsAlertSettingsSchema, {
        method: 'PUT',
        body: operationsAlertSettingsUpdateSchema.parse(input),
      }),
    onSuccess: (settings) => {
      client.setQueryData(operationsAlertSettingsKey, settings);
      void client.invalidateQueries({ queryKey: operationsAlertHistoryKey });
    },
  });
}

export function useOperationsAlertHistory(query: OperationsAlertListQuery) {
  const search = new URLSearchParams({
    page: String(query.page),
    pageSize: String(query.pageSize),
  });
  if (query.event) search.set('event', query.event);
  if (query.deliveryState) search.set('deliveryState', query.deliveryState);
  return useQuery({
    queryKey: [...operationsAlertHistoryKey, query],
    queryFn: () =>
      apiFetch(`/api/v1/operations/alerts?${search.toString()}`, operationsAlertListSchema),
  });
}
